/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowForward12: {
  name: 'arrow-forward-12';
  data: string;
} = {
  name: 'arrow-forward-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 2c.149 0 .294.047.417.134l4.499 3.2a.833.833 0 0 1 .208 1.11.777.777 0 0 1-.208.221l-4.5 3.2a.722.722 0 0 1-1.04-.221A.838.838 0 0 1 6 9.2v-.903c-.173-1.174-3.342-.979-4.823.7-.355.374-.818.168-1.049-.151A.655.655 0 0 1 .105 8.1C1.25 6.312 2.996 5.008 5.25 4.4c.38 0 .698-.347.75-.7.224-1.133.474-1.7.75-1.7z"/></svg>`
};
